<template>
  <main>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("route.plans_features") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="createPlan">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      pathName="plan-features"
      :headersName="headers"
      ref="table_ref"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>

        <td class="text-sm-center">
          <v-icon
            :title="$t('icon.edit')"
            small
            @click="handleEdit(item, index)"
            >mdi-pencil</v-icon
          >
          <v-icon
            :title="$t('icon.delete')"
            small
            @click="handleDelete(item, index)"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dialog -->
      <template #wrraping_dialog>
        <FormActions
          :v="$v"
          :form="form"
          :isEdit="isEdit"
          :loading="loading"
          @on_submit_form="handleSubmit"
          @change_locale="onLocaleChange"
        />
      </template>
      <!-- dialog -->
    </wrapping-table>
  </main>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  minValue,
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate.js";
import { ShowData } from "@/helpers/apiMethods";
import cookie from "js-cookie";

export default {
  name: "PlansFeatures",
  components: {
    FormActions: () => import("./formActions"),
  },
  data() {
    return {
      headers: ["name", "actions"],
      form: {
        name: "",
        value_type: "",
        default_value: "",
      },

      isEdit: false,
      loading: false,
      planIndex: "",
      locale: this.locale,
      planItem: {},
    };
  },

  methods: {
    onLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    },

    handleSubmit() {
      let reqData = {
        ...this.form,
        service_id: this.$route.query.service_id,
      };
      if (!this.isEdit) {
        // in case create
        this.loading = true;
        this.$refs.table_ref
          .handleOnCreate("plan-features", reqData, "plan_feature")
          .finally(() => {
            this.loading = false;
          });
      } else {
        // in case edit
        reqData = {
          ...reqData,
          _method: "put",

          locale: this.locale,
        };
        this.$refs.table_ref
          .handleOnEdit(
            "plan-features",
            reqData,
            this.planItem.id,
            "plan_feature",
            this.planIndex
          )
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onDialogClose() {
      this.$v.form.$reset();
      this.isEdit = false;
      this.locale = cookie.get("language");

      for (const key in this.form) {
        if (key !== "color") {
          this.form[key] = "";
        } else {
          this.form["color"] = {};
        }
      }
    },
    createPlan() {
      this.$refs.table_ref.toggleDialog();
    },
    handleEdit(item, index) {
      this.planItem = item;
      this.planIndex = index;
      this.isEdit = true;
      this.$refs.table_ref.toggleDialog();

      this.handleShow();
    },
    async handleShow(locale = this.locale) {
      const res = await ShowData({
        reqName: "plan-features",
        id: this.planItem.id,
        locale,
      });
      const { plan_feature } = res.data;
      this.form = plan_feature;
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      value_type: {
        required,
        numeric,
      },
      default_value: {
        required,
      },
    },
  },
};
</script>
